import React from 'react';

/**
 * Holds the latest value in a ref so an effect can read it without
 * resubscribing each time the value's identity changes. Useful for
 * callback props that a parent re-creates on every render but whose
 * behavior the effect can always invoke unconditionally: the effect
 * lists the ref-stable inputs in its deps, reads the callback through
 * the ref, and avoids the tear-down-and-rebind churn that would
 * otherwise reset timers and subscriptions on every parent render.
 */
export const useLatest = <T>(value: T): React.RefObject<T> => {
  const ref = React.useRef(value);
  React.useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref;
};
